import React from 'react';
import { Plus, ScrollText } from 'lucide-react';

const PlaybookSelector = ({ playbooks, selectedId, onSelect, onCreateNew }) => {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-1">
      {playbooks.map((pb) => {
        const isActive = pb.id === selectedId;
        return (
          <button
            key={pb.id}
            onClick={() => onSelect(pb.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg border text-sm font-medium whitespace-nowrap transition-colors ${
              isActive
                ? 'bg-primary text-primary-foreground border-primary'
                : 'bg-card text-foreground border-border hover:bg-muted'
            }`}
          >
            <ScrollText className="w-3.5 h-3.5" />
            {pb.name}
            {pb.rule_counts && (
              <span className={`text-xs ${isActive ? 'text-primary-foreground/70' : 'text-muted-foreground'}`}>
                ({pb.rule_counts.active})
              </span>
            )}
          </button>
        );
      })}
      <button
        onClick={onCreateNew}
        className="flex items-center gap-1.5 px-4 py-2 rounded-lg border border-dashed border-border text-sm font-medium text-muted-foreground hover:text-foreground hover:border-foreground/30 transition-colors whitespace-nowrap"
      >
        <Plus className="w-3.5 h-3.5" />
        New Playbook
      </button>
    </div>
  );
};

export default PlaybookSelector;
